import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import Friends from "../views/Friends.vue";
import Flamingo from "../views/visual_art/Flamingo.vue";
import Drawings from "../views/visual_art/Drawings.vue";
import Design from "@/views/visual_art/Design.vue";
import Sewing_yarn from "@/views/visual_art/Sewing_yarn.vue";
import Videos from "@/views/music_event/Videos.vue";
import Fpo_band from "@/views/music_event/Fpo_band.vue";
import Urfo_school_band from "@/views/music_event/Urfo_school_band.vue";
import Tutor_material from "@/views/club_forum_event/Tutor_material.vue";
import Club_activities from "@/views/club_forum_event/Club_activities.vue";
import Forum from "@/views/club_forum_event/Forum.vue";
import Friends from "@/views/other/Friends.vue";
import Cats_stations from "@/views/other/Cats_stations.vue";
import Downloads from "@/views/club_forum_event/Downloads.vue";
import About from "@/views/About.vue"
import Composition from "@/views/music_event/Composition.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  // {
  //   path: "/visual_art",
  //   name: "visual_art",
  //   component: VisualArt
  // },
  {
    path: "/visual_art/flamingo",
    name: "flamingo",
    component: Flamingo
  },
  {
    path: "/visual_art/drawings",
    name: "drawings",
    component: Drawings
  },
  {
    path: "/visual_art/design",
    name: "design",
    component: Design
  },
  {
    path: "/visual_art/sewing_yarn",
    name: "sewing_yarn",
    component: Sewing_yarn
  },
  // {
  //   path: "/music_event",
  //   name: "music_event",
  //   component: MusicEvent
  // },
  {
    path: "/music_event/video",
    name: "video",
    component: Videos
  },
  {
    path: "/music_event/fpo_band",
    name: "fpo_band",
    component: Fpo_band
  },
  {
    path: "/music_event/urfo_school_band",
    name: "urfo_school_band",
    component: Urfo_school_band
  },
  {
    path: "/music_event/composition",
    name: "music_event_composition",
    component: Composition
  },
  // {
  //   path: "/club_form_event",
  //   name: "club_form_event",
  //   component: ClubFormEvent
  // },
  {
    path: "/club_forum_event/tutor_material",
    name: "tutor_material",
    component: Tutor_material
  },
  {
    path: "/club_forum_event/club_activities",
    name: "club_activities",
    component: Club_activities
  },
  {
    path: "/club_forum_event/forum",
    name: "forum",
    component: Forum
  },  
  {
    path: "/club_forum_event/downloads",
    name: "downloads",
    component: Downloads
  },    
  // {
  //   path: "/cat_station",
  //   name: "cat_station",
  //   component: CatsStations
  // },
  {
    path: "/other/friends",
    name: "friends",
    component: Friends
  },  
  {
    path: "/other/cats_station",
    name: "cats_stations",
    component: Cats_stations
  },  

  {
    path: "/about",
    name: "about",
    component: About
  },

];

const router = new VueRouter({
  routes
});

export default router;
